/**
 * The page flow outside Present View: link → entries & prizes → draw → results.
 * Present View is a mode on top of the draw step, not a step of its own.
 * Steps live in the URL hash (`#/setup`), so the browser's Back button works.
 */
export const STEPS = ['video', 'setup', 'draw', 'results'];

/** `#/setup` → 'setup'; anything else → null. */
export function parseStep(hash) {
  const name = String(hash ?? '').replace(/^#\/?/, '');
  return STEPS.includes(name) ? name : null;
}

export const stepHash = (step) => `#/${step}`;

/** The step to show: nothing past the link page until comments are loaded. */
export function resolveStep(requested, { hasComments }) {
  if (!hasComments) return 'video';
  return STEPS.includes(requested) ? requested : 'setup';
}
